import { LoginPage } from "./PortalLogin";

export default function AdminLogin() {
  return (
    <LoginPage
      title="Admin sign-in."
      eyebrow="Admin"
      endpoint="/auth/admin/login"
      redirect="/admin"
      testidPrefix="admin-login"
      demoHint="Demo: admin@shumwaytech.com / admin123"
    />
  );
}
